import React from 'react';
import s from './BackStep.module.css';

export const BackStepItem = ({ text }) => (
    <div className={s.backItem}>
        <div className={s.backArrows} />
        {text}
    </div>
);
